import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Shield, Brain, Timer, Sword, CircleCheckBig } from 'lucide-react';
const features = [{
  title: 'El Búnker Digital',
  description: 'Estrategias de privacidad absolutas para desaparecer de su radar sin parecer herida. Corta el suministro de información.',
  icon: Shield
}, {
  title: 'Anatomía del Impulso',
  description: 'Toma el control de tu sistema nervioso. Aprende a hackear la urgencia química de escribirle o revisar sus redes.',
  icon: Brain
}, {
  title: 'Técnica 10 Minutos',
  description: 'El protocolo de emergencia para cuando la ansiedad ataca. Disciplina táctica para no ceder en los momentos de debilidad.',
  icon: Timer
}, {
  title: 'Protocolo de Resurrección',
  description: "Defensas psicológicas contra el 'orbiting' y los mensajes de tanteo. Cómo responder (o no) desde una posición de poder.",
  icon: Sword
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function FeatureGrid() {
  return <section className="py-32 px-6 bg-charcoal relative border-t border-gold/10" data-id="element-50">
      <div className="max-w-6xl mx-auto" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-52">
          <h2 className="font-playfair text-4xl md:text-5xl text-white mb-6" data-id="element-53">
            Lo Que Contiene Tu <span className="text-gold italic" data-id="element-54">Código</span>
          </h2>
          <div className="w-24 h-[1px] bg-gold mx-auto opacity-50" data-id="element-55" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-56">
          {features.map((feature, index) => <motion.div key={index} variants={itemVariants} className="bg-card p-10 rounded-sm border border-white/5 hover:border-gold/30 transition-all duration-500 group" data-id="element-57">
              <div className="flex items-start gap-5" data-id="element-58">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-gold/5 border border-gold/20 flex items-center justify-center group-hover:bg-gold/10 transition-colors duration-500" data-id="element-59">
                  <feature.icon className="w-5 h-5 text-gold" strokeWidth={1.5} data-id="element-60" />
                </div>
                <div data-id="element-61">
                  <div className="flex items-center gap-2 mb-3" data-id="element-62">
                    <CircleCheckBig className="w-5 h-5 text-gold flex-shrink-0" strokeWidth={2} data-id="element-63" />
                    <h3 className="font-playfair text-2xl text-gold" data-id="element-64">
                      {feature.title}
                    </h3>
                  </div>
                  <p className="font-sans text-gray-400 leading-relaxed font-light" data-id="element-65">
                    {feature.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}